import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import usePublicationBooking, { usePublicationBookingForm } from '@hooks/usePublicationBooking'
import useSelector from '@hooks/useSelector'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'
import handleCallbackAction from '@functions/handleCallbackAction'

import { findStatusByKey } from '@functions/status'

const MODAL_KEY = 'ManagePublicationBookingPreflightStatusModal'

type ModalCallbacks = {
  closeModal: () => void,
  updatePublicationBookingPreflightStatus: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const ManagePublicationBookingPreflightStatusModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { entityParams: initPublicationBooking } = modalPayload

  const { publication_booking_id } = initPublicationBooking
  const publicationBookingPayload = usePublicationBooking({ id: publication_booking_id })

  const {
    callbacks: {
      updatePublicationBookingPreflightStatus: updateFn,
    },
    publicationBooking,
    updating,
  } = publicationBookingPayload

  const { statuses } = useSelector(reduxState => reduxState.entities)

  const statusRejected = findStatusByKey(statuses, 'rejected')

  const publicationBookingFormPayload = usePublicationBookingForm({
    ...publicationBooking,
    // @ts-expect-error TS2339
    preflight_status_id: statusRejected.id,
  })

  const {
    entityState,
    entityState: {
      preflight_notes,
    },
    handlers,
  } = publicationBookingFormPayload

  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Publication Booking Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Reject" titleSecondLine="Preflight" />

      <SidebarModal.Content>
        <Form>
          <Form.Field
            label="Notes"
            // @ts-expect-error TS2322
            marginBottom="large"
          >
            <textarea
              name="preflight_notes"
              style={{ height: 120 }}
              // @ts-expect-error TS2322
              type="text"
              value={preflight_notes}
              {...handlers}
            />
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="secondaryDestroy"
          loading={updating}
          // @ts-expect-error TS2345
          onClick={() => handleCallbackAction(updatePublicationPayload)}
          size="large"
        >
          Reject
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManagePublicationBookingPreflightStatusModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
